import { createFileRoute, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/_org/settings/")({
  beforeLoad: () => {
    throw notFound();
  },
});
